import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectionContext, SelectionType } from '../../../contexts/SelectionContext';
import { PortfolioPeoplePage } from '../../PortfolioManagement/People/PortfolioPeoplePage';
import { ProjectTimePage } from './Time';

export const TimeSelectionFrame = () => {
    const { selectionMode } = useContext(SelectionContext);
    const { t } = useTranslation();
    return (
        <>
            <PortfolioPeoplePage
                isHidden={selectionMode !== SelectionType.HumanResource}
                pageTitle={t('windows.selectPerson')}
            />
            <ProjectTimePage isHidden={selectionMode !== undefined} />
        </>
    );
};
